<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.purchase_entry">
    <app-popup-header title="{{localService.languageContent.purchase_entry.history}}"></app-popup-header>
    <div class="modal-body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
        <div *ngFor="let item of items" class="styled_row">
            <div class="col-12">
                <div>
                    <span style="font-weight: bold;">{{item.v1}}</span>
                    <span class="en">&nbsp;:&nbsp;</span>
                    <span>{{item.v2}}</span>
                    <span class="en">&nbsp;->&nbsp;</span>
                    <span>{{item.v3}}</span>
                </div>
                <div style="text-align: right;">
                    <span>{{item.v4}}</span>
                    <span>&nbsp;{{localService.languageContent.purchase_entry.on}}&nbsp;</span>
                    <span>{{item.v5 | date : 'dd-MMM-yyyy hh:mm a'}}</span>
                </div>
            </div>
        </div>
    </div>
</div>